<template>
  <div class="card" v-if="pricelist">
    <div class="card-body">
      <div class="card-widgets">
        <small>
          <a href="" v-if="onlyClientPrices" @click.prevent="onlyClientPrices=false">Näita kõiki hindu</a>
          <a href="" v-if="!onlyClientPrices" @click.prevent="onlyClientPrices=true">Näita erihindu</a>
        </small>
      </div>

      <h4 class="card-title mt-0">Kliendi hinnakiri</h4>

      <div v-if="pricelist.length && (!hasOnlyGeneric || !onlyClientPrices)">
        <table class="table table-centered table-sm mt-3 mb-0 table-sticky">
          <thead>
          <tr>
            <th>Lisa arvele</th>
            <th>Teenus</th>
            <th class="text-right">Erihind</th>
            <th class="text-right">Üldhind</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="price in pricelist">
            <tr v-if="price.clientPrice || price.includeInBill || !onlyClientPrices">
              <td class="text-center">
                <i class="mdi text-success" :class="{'mdi-checkbox-marked': price.includeInBill}"></i>
              </td>
              <td>
                {{price.serviceName}}
              </td>
              <td class="text-right text-danger">
                <strong>{{price.clientPrice | amountWithCurrency}}</strong>
              </td>
              <td class="text-right">
                {{price.genericPrice | amountWithCurrency}}
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

      <div v-else class="row">
        <div class="col">
          Erihinnad puuduvad, vaata üldhindu
        </div>
      </div>


      <div class="mt-2">
        <permission name="ClientPricelistUpdate">
          <a href="#" @click.prevent="editPricelist" class="card-link text-primary">
            <i class="mdi mdi-pencil mr-1"></i>Muuda
          </a>
        </permission>
      </div>
    </div>

  </div>
</template>

<script>
  import gateway from '@/services/gateway'

  export default {
    props: ['clientId'],
    data() {
      return {
        pricelist: null,
        onlyClientPrices: true
      }
    },
    computed: {
      hasOnlyGeneric() {
        return !this.pricelist.find(p => (!!p.clientPrice || !!p.includeInBill));
      }
    },
    methods: {
      editPricelist() {
        this.$router.push('/client/edit-pricelist')
      },
      sortByServiceNameAsc(data) {
        data.sort((a, b) => {
          if (a.serviceName < b.serviceName) return -1;
          if (a.serviceName === b.serviceName) return 0;
          return 1;
        })
      },
      loadData(clientId) {
        gateway.get(`/clients/${clientId}/pricelist`).then(r => {
          this.pricelist = r.data.filter(p => p.clientPrice || p.genericPrice || p.includeInBill)
          this.sortByServiceNameAsc(this.pricelist)
        })
      }
    },
    created() {
      this.loadData(this.clientId)
    },
    watch: {
      'clientId'(newClientId) {
        this.loadData(newClientId)
      }
    }
  }
</script>
